import { render, staticRenderFns } from "./selectLabels.vue?vue&type=template&id=4bc21861&scoped=true"
import script from "./selectLabels.vue?vue&type=script&lang=js"
export * from "./selectLabels.vue?vue&type=script&lang=js"
import style0 from "./selectLabels.vue?vue&type=style&index=0&id=4bc21861&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc21861",
  null
  
)

export default component.exports